import { ChangeDetectorRef, Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from "@angular/common";
import { MainnavService, ViewType } from "../mainNav/mainnav.service";
import { CoreLogService } from '../../services/log.service';
import { animate, keyframes, style, transition, trigger } from "@angular/animations";
import { CheckoutComponent } from "../checkout/checkout.component";
import { WebShopService } from '../../services/webShop.service';
import { CustomerDataComponent } from '../customerData/customerData.component';
import { SnackBarService, snackBarMessageKey } from '../../services/snackBar.service';
import { SnackBarMessageType } from '../../shared/contentTypes';
import { InHouseOrderService } from '../../services/inHouseOrder.service';
import Utils from '../../shared/utils';
import { Subscription } from 'rxjs';
import { CoreCOMService } from '../../services/com.service';
import { InHousePaymentOrderComponent } from '../inHousePaymentOrder/inHousePaymentOrder.component';

const ORDER_NAVIGATION = "phPayment_Tab_Order_Overview";
const CUSTOMER_DATA_NAVIGATION = "phPayment_Tab_Order_Data";
const CHECKOUT_NAVIGATION = "phPayment_Tab_Order_Pay";

/** ??? */
@Component({
  selector: 'inHausePayment',
  templateUrl: './inHausePayment.component.html',
  styleUrls: ['./inHausePayment.component.scss'],
  // todo onPush?
  animations: [
    trigger('shake', [
      transition('* => *', animate('1000ms ease-in',
        keyframes([
          style({ transform: 'translate3d(-1px, 0, 0)', offset: 0.1 }),
          style({ transform: 'translate3d(2px, 0, 0)', offset: 0.2 }),
          style({ transform: 'translate3d(-4px, 0, 0)', offset: 0.3 }),
          style({ transform: 'translate3d(4px, 0, 0)', offset: 0.4 }),
          style({ transform: 'translate3d(-4px, 0, 0)', offset: 0.5 }),
          style({ transform: 'translate3d(4px, 0, 0)', offset: 0.6 }),
          style({ transform: 'translate3d(-4px, 0, 0)', offset: 0.7 }),
          style({ transform: 'translate3d(2px, 0, 0)', offset: 0.8 }),
          style({ transform: 'translate3d(-1px, 0, 0)', offset: 0.9 }),
        ]))
      ),
    ]),
  ]
})
export class InHausePaymentComponent implements OnInit, OnDestroy {
  @ViewChild(CheckoutComponent) checkout: CheckoutComponent;
  @ViewChild(CustomerDataComponent) customerData: CustomerDataComponent;
  @ViewChild(InHousePaymentOrderComponent) inhousePaymentOrder: InHousePaymentOrderComponent;

  public paymentNavigations: string[];
  public matGroupSelectedIndex: number = 0;
  public activeLink: string;
  public states = {};
  public useBrowserHistory: boolean = true;
  public isSmallView: boolean = false;
  public getCustomerData: boolean = false;

  private _onPaymentSelectAbortedSubscrition: Subscription;
  private _resumeSupscription: Subscription;

  constructor(private _router: Router
    , private _snackBarService: SnackBarService
    , private _location: Location
    , private _changeDetectorRef: ChangeDetectorRef
    , private _coreCOMService: CoreCOMService
    , private _coreLogService: CoreLogService
    , private _webShopService: WebShopService
    , private _inHouseOrderService: InHouseOrderService
    , mainnavService: MainnavService) {
    const me = this;
    me.paymentNavigations = [ORDER_NAVIGATION];
    me.activeLink = ORDER_NAVIGATION;
    me.isSmallView = mainnavService.viewType === ViewType.Small;
  }

  ngOnInit() {
    const me = this;
    me._inHouseOrderService.GetStatus().then((status) => {
      if (status.has_pos_connection && !Utils.IsNullOrEmpty(status.table_no) && status.customer) {
        me.getCustomerData = me._webShopService.hasCustomerInputFields;
        if (me.getCustomerData) {
          me.paymentNavigations.push(CUSTOMER_DATA_NAVIGATION);
        }
        me.paymentNavigations.push(CHECKOUT_NAVIGATION);

        me._resumeSupscription = me._coreCOMService.environment.events.resume.subscribe(async () => {
          // TODO dialog/info, user war weg vom payment, verbinung wurde getrennt und es nochmal probiert werden sollte
          me.retrunToInHauseServiceSelector();
        });

        me._onPaymentSelectAbortedSubscrition = me._inHouseOrderService.ObserveOnPaymentSelectAborted.subscribe(() => {
          // TODO dialog/info, das es zu einem problem kam und es nochmal probiert werden sollte
          me.retrunToInHauseServiceSelector(); // navigate back to table
        });

        me.PushChanges();
      } else {
        me._coreLogService.debug("InHauseServicePaymentComponent.ngOnInit", "status is not okay");
        me._router.navigate(["/"]); // back to home
        return; // exit here
      }
    }).catch((error) => {
      me._coreLogService.error("InHauseServicePaymentComponent.ngOnInit", "inHouseOrderService.GetStatus(catch)", error);
      me._router.navigate(["/"]); // back to home
      return; // exit here
    });
  }

  ngOnDestroy(): void {
    const me = this;

    if (me._onPaymentSelectAbortedSubscrition) {
      me._onPaymentSelectAbortedSubscrition.unsubscribe();
    }
    if (me._resumeSupscription) {
      me._resumeSupscription.unsubscribe();
    }
    if (me._inHouseOrderService) {
      me._inHouseOrderService.AbortPaymentSelect(); // try abort Payment Select
    }
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("InHauseServicePaymentComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  public ShakeLabel(stateVar: string) {
    const me = this;
    me.states[stateVar] = !me.states[stateVar];
  }

  /** navigiert zurück zur InHouse Landingpage */
  private retrunToInHauseServiceSelector(): void {
    const me = this;
    me._inHouseOrderService.openInHauseLandingPage();
  }

  // control the tab change in top navigation and page tabs
  public changeTab(index: number) {
    const me = this;
    if (me.getCustomerData && index <= 1 && me.matGroupSelectedIndex <= 1) { // Don't close when navigating back
      me.customerData.toggleBillingInfo(true); // Close DeliveryAddress if open
    }
    me.matGroupSelectedIndex = index;
    me.activeLink = me.paymentNavigations[index];
    me.PushChanges();
  }

  public onContinue_order() {
    const me = this;
    if (me.getCustomerData) {
      me.NavigateToCustomerData();
    } else {
      me.NavigateToCheckout();
    }
  }

  private async NavigateToCustomerData() {
    this.changeTab(1);
  }

  public onContinue_customerData() {
    this.NavigateToCheckout();
  }

  /**Navigate to check out*/
  private NavigateToCheckout() {
    const me = this;
    me.openCheckout();
  }

  private openCheckout() {
    const me = this;
    me._webShopService.onUserChange().then(() => {
      me._webShopService.createAddPurchaseOrderDataModel(false).then(order => {
        me.changeTab(me.getCustomerData ? 2 : 1);
        me.checkout.initialize(order, me._webShopService.userWebvoucher);
      });
    }).catch((e) => {
      me._coreLogService.error("WebshopComponent.PushChanges", "_webShopService.onUserChange (catch)", e);
      me._snackBarService.ShowErrorMessageFailed(46);
    });
  }

  /** navigation back by swiping from left to right,
   *  if smallview and tipslider is not sliding */
  public SwiperNavigateBack() {
    const me = this;
    if (me.isSmallView && !me.inhousePaymentOrder.tipSlider._isSliding) {
      me.navigateBack();
    }
  }

  public navigateBack() {
    const me = this;
    me.navigateToPreviousTab();
  }

  private navigateToPreviousTab() {
    const me = this;
    if (me.matGroupSelectedIndex > 0) {
      me.changeTab(me.matGroupSelectedIndex - 1);
    } else if (me.useBrowserHistory) {
      me._location.back()
    } else {
      me._inHouseOrderService.openInHauseLandingPage();
    }
  }

}